import React, {useMemo} from 'react'
import Select, {createSelectItem} from "components/Select";
import GridBlock from "components/GridBlock";
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/styles";
import IconButton from "components/button/IconButton";
import ArrowIconLeft from "@material-ui/icons/KeyboardArrowLeft";
import ArrowIconRight from "@material-ui/icons/KeyboardArrowRight";
import {Paper} from "@material-ui/core";
import Button from "../../../Button";
import PlusOneIcon from "@material-ui/icons/PlusOne";
import getObjectValue from "../../../../libs/getObjectValue";

const useStyle = makeStyles(theme => ({
    root: {
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        top: 162,
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
    },
    paper: {
        border: `solid 2px ${theme.palette.border.dark}`,
        padding: theme.spacing(0.25)
    },
    select: {
        minWidth: 250
    },
    margin: {
        margin: `0 ${theme.spacing()}px`
    }
}))

function DealingsNavigator(
    {
        formikProps,
        id,
        items,
        hideItem,
        addPart,
        partTranslationKey = "part_x",
        choosePositionTranslationKey = "choose_position"
    }) {
    const classes = useStyle();
    const editable = getObjectValue('_editable', formikProps.values, true);
    const passive = getObjectValue('_passive', formikProps.values, false);
    const onlyNotice = getObjectValue('_onlyNotice', formikProps.values, false);
    const updateNotice = getObjectValue('_updateNotice', formikProps.values, true);
    // eslint-disable-next-line
    const memoItems = useMemo(() => {
        const arr = items.map((x, i) => createSelectItem(i, Tr(partTranslationKey, {x: i + 1}), undefined, hideItem && hideItem(i)));
        arr.unshift(createSelectItem(-1, Tr(choosePositionTranslationKey)));
        return arr;
    }, [items, partTranslationKey, choosePositionTranslationKey, hideItem])
    const lastNotHiddenIndex = hideItem ? memoItems.filter(x => !x.hidden).map(x => x.value).pop() : (items.length - 1);

    const curIndex = formikProps.values[id];

    const moveToPreviousPart = () => {
        if (curIndex < 0) {
            return;
        }

        let tmpIndex = curIndex - 1;
        while (tmpIndex >= 0) {
            const ix = tmpIndex;
            const elem = memoItems.find(x => x.value === ix);
            if (elem && !elem.hidden) {
                formikProps.setFieldValue(id, elem.value);
                return;
            }
            tmpIndex -= 1;
        }

        return -1;
    }

    const moveToNextPart = () => {
        let tmpIndex = curIndex + 1;
        while (tmpIndex <= memoItems[memoItems.length - 1].value) {
            const ix = tmpIndex;
            const elem = memoItems.find(x => x.value === ix);
            if (elem && !elem.hidden) {
                formikProps.setFieldValue(id, elem.value);
                return;
            }
            tmpIndex += 1;
        }

        return curIndex;
    }

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <GridBlock justify="space-evenly" alignItems="center">
                    <GridBlock justify="center" alignItems="center">
                        <IconButton
                            className={classes.margin}
                            disabled={curIndex < 0}
                            tooltip={curIndex > -1 ? Tr(partTranslationKey, {x: curIndex}) : Tr('select')}
                            variant="outlined"
                            onClick={hideItem ? (() => moveToPreviousPart()) : (() => formikProps.setFieldValue(id, curIndex - 1))}
                            Icon={ArrowIconLeft}/>
                        <Select className={classes.select} formikProps={formikProps} id={id} items={memoItems} noError alwaysEditable/>
                        <IconButton
                            className={classes.margin}
                            disabled={curIndex === lastNotHiddenIndex}
                            tooltip={curIndex < items.length - 1 ? Tr(partTranslationKey, {x: curIndex + 2}) : undefined}
                            variant="outlined"
                            onClick={hideItem ? (() => moveToNextPart()) : (() => formikProps.setFieldValue(id, curIndex + 1))}
                            Icon={ArrowIconRight}/>
                    </GridBlock>
                    {(onlyNotice || passive) && !!addPart && <Button Icon={PlusOneIcon} onClick={addPart} disabled={updateNotice || !editable}>{Tr('add_part')}</Button>}
                </GridBlock>
            </Paper>
        </div>)
}

DealingsNavigator.propTypes = {};

export default DealingsNavigator;
